import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "tw-w-full tw-bg-gray-50 proximos-turnos" }
const _hoisted_2 = { class: "md:tw-hidden tw-w-full tw-flex tw-justify-center md:tw-justify-end tw-items-center tw-space-x-2" }
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 0,
  class: "tw-w-full tw-text-center tw-pb-2"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "tw-text-green-600 tw-text-lg" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Nueva Cita asignada.")
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "tw-flex tw-w-full" }
const _hoisted_8 = { class: "tw-hidden lg:tw-flex tw-justify-center tw-items-center tw-px-4" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "tw-space-y-1 tw-flex-1 tw-px-4 tw-text-left tw-flex tw-flex-col tw-justify-center" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = {
  class: "tw-mr-3 md:tw-mr-0 tw-text-xl",
  style: {"color":"var(--primary-color)"}
}
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "tw-text-lg" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "tw-hidden md:tw-flex tw-flex-col tw-justify-start tw-items-center md:tw-space-y-2" }
const _hoisted_18 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, {
      class: _normalizeClass(["p-shadow-5", _ctx.$route.query && _ctx.$route.query.q === `${_ctx.turno.id}` ? "tw-border tw-border-green-500 tw-bg-green-50 tw-rounded" : "" ])
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (!_ctx.salaVideoConsulta)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                label: "",
                class: "p-button-outlined",
                icon: "pi pi-print"
              }))
            : _createCommentVNode("", true),
          (_ctx.isCancelable)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                label: "",
                onClick: _ctx.handleConfirmarCancelacion,
                class: "p-button-danger p-button-outlined",
                icon: "pi pi-trash"
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.salaVideoConsulta)
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                href: _ctx.salaVideoConsulta,
                target: "_blank",
                class: "p-button p-component"
              }, "Acceder a la sala", 8, _hoisted_3))
            : _createCommentVNode("", true)
        ])
      ]),
      content: _withCtx(() => [
        (_ctx.$route.query && _ctx.$route.query.q === `${_ctx.turno.id}`)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("img", {
              src: _ctx.logo,
              alt: "Logo",
              width: "100%",
              height: "100%",
              style: {"width":"100px","height":"100px","object-fit":"contain"},
              class: "tw-rounded-full tw-border tw-border-gray-300 p-shadow-2"
            }, null, 8, _hoisted_9)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.fecha) + "hs", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", _hoisted_14, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.turno.medicoEspecialidad.medico.nombre), 1)
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("span", null, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.turno.medicoEspecialidad.servicioEspecialidad.descripcion), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("p", _hoisted_16, _toDisplayString(`${_ctx.turno.medicoEspecialidad.sucursal.sucursal} - ${_ctx.turno.medicoEspecialidad.sucursal.direccion}`), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            (!_ctx.salaVideoConsulta)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  onClick: _ctx.handleImprimirTurno,
                  label: "Imprimir",
                  class: "tw-hidden md:tw-block p-button-outlined tw-w-full",
                  icon: "pi pi-print "
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.isCancelable)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  onClick: _ctx.handleConfirmarCancelacion,
                  label: "Cancelar Cita",
                  class: "tw-hidden md:tw-block p-button-danger p-button-outlined tw-w-full",
                  icon: "pi pi-trash"
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.salaVideoConsulta)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 2,
                  href: _ctx.salaVideoConsulta,
                  target: "_blank",
                  class: "p-button p-component"
                }, "Acceder a la sala", 8, _hoisted_18))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["class"])
  ]))
}